<template>
  <div class="home">
    <toast />
    <div class="header fRow jStart primary aCenter fullWidth fixed" v-if="true">
      <a :href="appName.site"
        :class="`centerContain ${appName.name}Logo`"></a>
      <div class="item fRow jStart aCenter"
        @click="goToClasses()"
        v-if="loggedIn && !getStudentInfo">
        <i class="material-icons-round">date_range</i>
        <label>برنامه کلاسها</label>
      </div>
      <div class="growFull options fRow jEnd aCenter">
        <!-- <a href="#" class="item fRow jStart aCenter">
          <i class="material-icons-round">info</i>
          <label>سؤالات رایج</label>
        </a> -->
        <i class="material-icons-round userIcon" v-if="!loggedIn && !getStudentInfo"
          @click="toggleUserDropDown">account_circle</i>
        <div class="userAvatar" v-bind:class="{open: userDropDown}"
          v-bind:style="{backgroundImage: `url('${userAvatar}')`}"
          v-if="(loggedIn && !getStudentInfo) && hasAvatar" @click="toggleUserDropDown"></div>
        <div class="userAvatar def" v-bind:class="{open: userDropDown}"
          v-if="(loggedIn && !getStudentInfo) && !hasAvatar" @click="toggleUserDropDown"></div>
        <div class="dropDown" v-if="!loggedIn"
          @click="toggleUserDropDown" v-bind:class="{open: userDropDown}">
          <div class="dropDownContent">شما هنوز وارد حساب کاربری‌تان نشده‌اید</div>
        </div>
        <div class="dropDown loged" v-if="loggedIn" v-bind:class="{open: userDropDown}">
          <div class="dropDownContent fullWidth fRow jStart aCenter">
            <div class="userAvatar big" v-if="hasAvatar"
              v-bind:style="{backgroundImage: `url('${userAvatar}')`}"></div>
            <div class="userAvatar big def" v-if="!hasAvatar"></div>
            <div class="fCol jCenter aStart growFull">
              <div class="name">{{userName}}</div>
              <div class="phone" v-if="isTeacher">حساب دبیــر</div>
              <div class="phone" v-if="!isTeacher">حساب دانش‌آموز</div>
              <div class="btn fRow jStart aCenter transition-medium" @click="logOut">
                <i class="material-icons-round">exit_to_app</i>
                <label>خروج از حساب</label>
              </div>
            </div>
            <i class="material-icons-round" @click="toggleUserDropDown">close</i>
          </div>
        </div>
      </div>
    </div>
    <div class="rotatePhone fCol jCenter aCenter" v-if="false">
      <!-- <lottie-player src="https://class.rimik.ir/rotatePhone.json" background="transparent" speed="1"
        style="width: 196px; height: 196px;" loop autoplay></lottie-player> -->
      <lottie-animation
        path="./animations/icon.json"
        :loop="true"
        :autoPlay="true"
        :width="128"
        :height="128"/>
      <span>خارج از زمان دسترسی</span>
      <span class="mini">سیستم کلاس مجازی {{appName.faName}}
        از 7 صبح تا 11 شب قابل دسترسی می‌باشد</span>
    </div>
    <div class="noChrome fCol jCenter aCenter" v-if="false">
      <!-- <lottie-player src="https://class.rimik.ir/rotatePhone.json" background="transparent" speed="1"
        style="width: 196px; height: 196px;" loop autoplay></lottie-player> -->
      <lottie-animation
        path="./animations/chrome.json"
        :loop="true"
        :autoPlay="true"
        :width="128"
        :height="128"/>
      <span>دسترسی به کلاس تنها از طریق مرورگر «گوگل کروم» امکان‌پذیر است.
        در صورت نیاز از لینک زیر دریافت کنید</span>
        <a href="https://www.google.com/chrome"
          v-if="osDetected === 'Windows' || osDetected === 'Mac OS'">دریافت گوگل کروم</a>
        <a href="https://play.google.com/store/apps/details?id=com.android.chrome"
          v-if="osDetected === 'Android'">دریافت کروم برای android</a>
        <a href="https://apps.apple.com/us/app/google-chrome/id535886823"
          v-if="osDetected === 'iOS'">دریافت کروم برای ios</a>
      <!-- <span class="mini">سیستم </span> -->
    </div>
    <div class="noChrome fCol jCenter aCenter" v-if="false">
      <!-- <lottie-player src="https://class.rimik.ir/rotatePhone.json" background="transparent" speed="1"
        style="width: 196px; height: 196px;" loop autoplay></lottie-player> -->
      <lottie-animation
        path="./animations/notIran.json"
        :loop="true"
        :autoPlay="true"
        :width="228"
        :height="228"/>
      <span class="mini">شما در حال
        حاضر با آی‌پی کشور {{currentCountry}} وارد شده اید.</span>
      <span>لطفاً وی‌پی‌ان خود را خاموش کنید</span>
      <hr>
      <span class="mini">
        سیستم کلاس مجازی {{appName.faName}} تنها از داخل ایران قابل دسترسی می‌باشد</span>
    </div>
    <div class="loading primary fixed fCol jCenter aCenter" v-bind:class='{hide: documentLoad}'>
      <lottie-animation
        :path="`./animations/${appName.name}.json`"
        :loop="true"
        :autoPlay="true"
        :width="128"
        :height="128"/>
    </div>
    <keep-alive>
      <div class="fixed content background" v-if='!classMode && !false && !false'
        ref="content">
        <div class="getPhone fCol jCenter aStart">
          <div class="l fCol jCenter aCenter" v-if='loads'>
            <lottie-animation
              path="./animations/progress.json"
              :loop="true"
              :autoPlay="true"
              :width="96"
              :height="96"/>
          </div>
          <div class="finalPage fCol jStart aCenter" v-if='readyToShare'>
            <div class="holder">
              <textarea name="fake" ref="total" v-model="classTotal"
                cols="30" rows="100"></textarea>
              <h2>کلاس با موفقیت ایجاد شد</h2>
              <p>اطلاعات ورود مدرس برای شما پیامک خواهد شد.</p>
              <p class="warn">قبل از بستن صفحه حتما اطلاعات کلاس را
                با دانش‌آموزان به اشتراک بگذارید</p>
              <i class="material-icons-round down">keyboard_arrow_down</i>
              <div class="fRow fullWidth jCenter aCenter shareTitle">
                <div class="line"></div>
                <span>اشتراک گذاری اطلاعات کلاس</span>
                <div class="line"></div>
              </div>
              <div class="fRow fullWidth jBetween aCenter wrap">
                <ShareNetwork
                    class="w33"
                    network="Telegram"
                    :url="`https://class.${appName.name}.ir`"
                    :title="`🔖 ${className}`"
                    :description="computedDesc"
                    quote="«کلاس رأس ساعت آغاز خواهد شد»"
                    :hashtags="`کلاس_مجازی_${appName.name}`">
                    <div class="shareBtn fullWidth fRow jBetween aCenter transition-fast">
                      <div class="ic telegram"></div>
                      <label>تلگرام</label>
                    </div>
                </ShareNetwork>
                <ShareNetwork
                    class="w33"
                    network="WhatsApp"
                    :url="`https://class.${appName.name}.ir`"
                    :title="`🔖 ${className}`"
                    :description="computedDesc"
                    quote="«کلاس رأس ساعت آغاز خواهد شد»"
                    :hashtags="`کلاس_مجازی_${appName.name}`">
                    <div class="shareBtn fullWidth fRow jBetween aCenter transition-fast">
                      <div class="ic whatsapp"></div>
                      <label>واتسپ</label>
                    </div>
                </ShareNetwork>
                <div class="shareBtn fRow jBetween aCenter w33 transition-fast" @click="copyDesc">
                  <div class="ic copy"></div>
                  <label>کپی</label>
                </div>
              </div>
              <div class="freeSpace"></div>
              <div class="shareBtn back fRow jBetween aCenter transition-fast" @click="refresh">
                <i class="material-icons-round">home</i>
                <label>بازگشت به برنامه</label>
              </div>
            </div>
          </div>
          <!-- گرفتن اسم -->
          <div class="getName secondary fCol jCenter aCenter" v-if="getStudentInfo">
            <h2>تکمیل مشخصات پروفایل</h2>
            <p>نام و نام خانوادگی‌تان را وارد کنید</p>
            <div class="freeSpace">
              <div class="f16"></div>
            </div>
            <div class="fRow jStart aCenter fullWidth inputWraper">
              <i class="inputIcon material-icons-round">account_circle</i>
              <input class="transition-fast" placeholder="مثلاً: محمدرضا"
                type="text" @keyup.enter="updateProfile" v-model="userFirstName">
              <radial-progress-bar :diameter="24" class="remainingTime"
                v-bind:style="{marginRight: '8px'}"
                :completed-steps="userFirstName.length"
                startColor="var(--primary)"
                stopColor="var(--secondary)"
                innerStrokeColor="var(--normalText15)"
                :animateSpeed='100'
                :innerStrokeWidth="1"
                :strokeWidth="2"
                :total-steps="35">
              </radial-progress-bar>
            </div>
            <div class="fRow jStart aCenter fullWidth inputWraper">
              <i class="inputIcon material-icons-round">account_circle</i>
              <input class="transition-fast" placeholder="مثلاً: علیزاده"
                type="text" @keyup.enter="updateProfile" v-model="userLastName">
              <radial-progress-bar :diameter="24" class="remainingTime"
                v-bind:style="{marginRight: '8px'}"
                :completed-steps="userLastName.length"
                startColor="var(--primary)"
                stopColor="var(--secondary)"
                innerStrokeColor="var(--normalText15)"
                :animateSpeed='100'
                :innerStrokeWidth="1"
                :strokeWidth="2"
                :total-steps="50">
              </radial-progress-bar>
              <i class="material-icons-round fab fRow jCenter aCenter transition-fast"
                v-bind:class="{ready: userFirstName.length >= 2 && userLastName.length >= 2}"
                @click='updateProfile'>save</i>
            </div>
            <span class="errorMsg" v-if="reqError">{{reqErrorMsg}}</span>
          </div>
          <!-- گرفتن شماره تماس -->
          <div class="fCol fullWidth jStart aStart secHolder"
            v-bind:class="{wait: loads}" v-if="getPhone">
            <div class="tabRow fRow jCenter aCenter fullWidth transition-cubic" v-if="false">
              <div class="arrow transition-cubic" v-bind:style="{left: `${arrowPos}`}"></div>
              <div class="tabBtn fRow jCenter aCenter transition-cubic"
                v-bind:class="{active: userType === 1}"
                @click="toggleUserType('student')">
                <i class="material-icons-round">school</i>
                <label>ورود دانش‌آموزان</label>
              </div>
              <div class="tabBtn fRow jCenter aCentertransition-cubic"
                v-bind:class="{active: userType === 2}"
                @click="toggleUserType('teacher')">
                <i class="material-icons-round">assignment_ind</i>
                <label>ورود دبیران</label>
              </div>
            </div>
            <h2>به کلاس مجازی {{appName.faName}} خوش آمدید!</h2>
            <p>جهت ورود ابتدا شماره همراهتان را وارد کنید.</p>
            <div class="freeSpace">
              <div class="f16"></div>
            </div>
            <div class="fRow jStart aCenter fullWidth inputWraper">
              <i class="inputIcon material-icons-round">phone_iphone</i>
              <input class="transition-fast" placeholder="مثلاً: 09123456789"
                v-bind:class="{ready: phoneIsReady}"
                type="number" @keyup.enter="registerRequest" v-model="phone">
              <radial-progress-bar :diameter="24" class="remainingTime"
                v-bind:style="{marginRight: '8px'}"
                :completed-steps="phone.length"
                startColor="var(--primary)"
                stopColor="var(--secondary)"
                innerStrokeColor="var(--normalText15)"
                :animateSpeed='100'
                :innerStrokeWidth="1"
                :strokeWidth="2"
                :total-steps="11">
              </radial-progress-bar>
              <i class="material-icons-round fab fRow jCenter aCenter transition-fast"
                v-bind:class="{ready: phoneIsReady}"
                @click='registerRequest'>keyboard_backspace</i>
            </div>
            <span class="errorMsg" v-if="reqError && !goToAssignment">{{reqErrorMsg}}</span>
            <div class="fullWidth fCol jStart aStart goToAssignment" v-if="goToAssignment">
              <div class="fRow jStart aCenter">
                <i class="material-icons-round big">info</i>
                <span class="title">شماره شما ثبت نشده است</span>
              </div>
              <p class="desc">برای ورود به کلاس {{appName.faName}} ابتدا تفاهم نامه را تکمیل کنید و
                و دوباره به همین صفحه بازگردید و برای ورود اقدام کنید.
              </p>
              <a class="b fRow jStart aCenter" href="https://app.rimik.ir/assignment"
                target="_blank">
                <i class="material-icons-round">assignment</i>
                <label>تکمیل فرم تفاهم نامه</label>
              </a>
            </div>
          </div>
          <!-- گرفتن کد وریفای -->
          <div class="fCol fullWidth jStart aStart secHolder"
            v-bind:class="{wait: loads}" v-if="getVerification">
            <h2>کد تأیید برای شما ارسال شد!</h2>
            <div class="verifyLine" style="margin-bottom: 16px;">
              <div class="phonePreviewText">کد 6 رقمی ارسال شده به</div>
              <div class="phonePreview fRow jStart aCenter">{{phone}}
                <i class="material-icons-round primary ready fRow jCenter aCenter transition-fast"
                @click='activeGetPhone'>edit</i>
              </div>
              <div class="phonePreviewText">را وارد کنید</div>
            </div>
            <div class="fullWidth fRow jStart aCenter">
              <div class="fRow jStart aCenter growFull inputWraper">
                <i class="inputIcon material-icons-round">vpn_key</i>
                <input class="transition-fast" placeholder="123456"
                  type="number" @keyup.enter="verifyRequest" v-model="verifyCode">
              </div>
              <i class="material-icons-round fab fRow jCenter aCenter transition-fast"
                v-bind:class="{ready: codeIsReady}" @click='verifyRequest'>keyboard_backspace</i>
              <i class="material-icons-round fab fRow jCenter aCenter transition-fast active"
                v-if="this.waitForRecode <= 0" @click='registerRequest'
                style="margin: 0 8px 0 0;">repeat</i>
              <radial-progress-bar :diameter="48" class="remainingTime"
                v-bind:style="{marginRight: '8px'}"
                v-if="waitForRecode > 0"
                :completed-steps="this.$store.state.globalTimer"
                startColor="var(--primary)"
                stopColor="var(--secondary)"
                innerStrokeColor="var(--normalText15)"
                :animateSpeed='100'
                :innerStrokeWidth="2"
                :strokeWidth="4"
                :total-steps="secs">
                <p class="remaining">{{secToMinTimer}}</p>
              </radial-progress-bar>
            </div>
            <span class="errorMsg" v-if="reqError">{{reqErrorMsg}}</span>
          </div>
          <!-- گرفتن آی دی پسورد روم -->
          <div class="fCol fullWidth jStart aStart secHolder"
            v-bind:class="{wait: loads}" v-if="joinForm && !getStudentInfo">
            <h2>{{userName}} خوش آمدید!</h2>
            <div class="freeSpace"><div class="f8"></div></div>
            <div class="tabRow fRow jCenter aCenter fullWidth transition-cubic">
              <div class="arrow transition-cubic" v-bind:style="{left: `${arrowPos}`}"></div>
              <div class="tabBtn fRow jCenter aCenter transition-cubic"
                v-bind:class="{active: joinClassMode}"
                @click="toggleJoinClass('join')">
                <i class="material-icons-round">school</i>
                <label>ورود به کلاس</label>
              </div>
              <div class="tabBtn fRow jCenter aCenter transition-cubic"
                v-bind:class="{active: !joinClassMode}"
                @click="toggleJoinClass('record')">
                <i class="material-icons-round">assignment_ind</i>
                <label>مشاهده کلاس</label>
              </div>
            </div>
            <div class="joinRoomSection fullWidth" v-if="joinClassMode">
              <p v-if="!isJoinedClass">برای ورود به کلاس، شناسه و رمز عبور را وارد کنید</p>
              <div class="freeSpace" v-if="!isJoinedClass"><div class="f8"></div></div>
              <div class="fRow jStart aCenter fullWidth inputWraper" v-if="!isJoinedClass">
                <i class="inputIcon material-icons-round">duo</i>
                <input class="transition-fast latin"
                  @keyup="riir"
                  v-bind:class="{ready: roomIdIsReady}"
                  placeholder="شناسه‌ی کلاس" type="text" v-model="roomId">
                <radial-progress-bar :diameter="24" class="remainingTime"
                  v-bind:style="{marginRight: '8px'}"
                  :completed-steps="roomId.length"
                  startColor="var(--primary)"
                  stopColor="var(--secondary)"
                  innerStrokeColor="var(--normalText15)"
                  :animateSpeed='100'
                  :innerStrokeWidth="1"
                  :strokeWidth="2"
                  :total-steps="9">
                </radial-progress-bar>
              </div>
              <div class="fRow jStart aCenter fullWidth inputWraper" v-if="!isJoinedClass">
                <i class="inputIcon material-icons-round">vpn_key</i>
                <input class="transition-fast latin" placeholder="رمز ورود کلاس"
                  v-bind:class="{ready: roomPasswordIsReady}"
                  type="password" v-model="roomPassword" @keyup="rpir">
                <radial-progress-bar :diameter="24" class="remainingTime"
                  v-bind:style="{marginRight: '8px'}"
                  :completed-steps="roomPassword.length"
                  startColor="var(--primary)"
                  stopColor="var(--secondary)"
                  innerStrokeColor="var(--normalText15)"
                  :animateSpeed='100'
                  :innerStrokeWidth="1"
                  :strokeWidth="2"
                  :total-steps="8">
                </radial-progress-bar>
              </div>
              <!-- دکمه ها  -->
              <div class="fullWidth fRow jStart aCenter" v-bind:style="{width: '234px'}"
                v-if="!isJoinedClass">
                <div class="transition-fast fRow jStart fullWidth aCenter btn"
                  href="#" @click='joinClass'>
                  <i class="material-icons-round">login</i>
                  <label>درخواست ورود به کلاس</label>
                </div>
              </div>
              <div class="joinedSec"
                v-if="isJoinedClass">
                <h2>درخواست ورود به کلاس «{{joinClassData.class}}» تأیید شد</h2>
                <div class="fCol fullWidth jStart aStart">
                  <div class="fRow jStart aCenter rh">
                    <i class="material-icons-round">school</i>
                    <div class="teach">مدرس {{joinClassData.teacher}}</div>
                  </div>
                  <div class="fRow jStart aCenter rh">
                    <i class="material-icons-round mini">date_range</i>
                    <div class="date">{{joinClassData.time}}</div>
                  </div>
                </div>
                <div class="freeSpace">
                  <div class="f8"></div>
                </div>
                <div class="fullWidth fRow jStart aCenter fRow">
                  <div class="transition-fast fRow jStart aCenter btn new blink"
                    href="#" @click='openClass'>
                    <i class="material-icons-round">meeting_room</i>
                    <label>ورود به کلاس</label>
                  </div>
                  <div class="transition-fast fRow jStart aCenter btn mini"
                    href="#" @click='isJoinedClass = false; reqError = false' ref="exit"
                    style="margin-right: 8px; background-image: #646464;">
                    <i class="material-icons-round">exit_to_app</i>
                    <label>خروج</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="watchClassSection fullWidth" v-if="!joinClassMode">
              <p>برای مشاهده‌ی کلاس ضبط شده، شناسه کلاس را وارد کنید</p>
              <div class="freeSpace"><div class="f8"></div></div>
              <div class="fRow jStart aCenter fullWidth inputWraper">
                <i class="inputIcon material-icons-round">duo</i>
                <input class="transition-fast latin" v-bind:class="{ready: roomIdIsReady}"
                  placeholder="شناسه‌ی کلاس" type="text" v-model="roomId">
                <radial-progress-bar :diameter="24" class="remainingTime"
                  v-bind:style="{marginRight: '8px'}"
                  :completed-steps="roomId.length"
                  startColor="var(--primary)"
                  stopColor="var(--secondary)"
                  innerStrokeColor="var(--normalText15)"
                  :animateSpeed='100'
                  :innerStrokeWidth="1"
                  :strokeWidth="2"
                  :total-steps="9">
                </radial-progress-bar>
              </div>
              <!-- دکمه ها  -->
              <div class="fullWidth fRow jStart aCenter" v-bind:style="{width: '164px'}">
                <div class="transition-fast fRow jStart fullWidth aCenter btn"
                  href="#" @click='watchClassRequest'>
                  <i class="material-icons-round">login</i>
                  <label>دریافت اطلاعات</label>
                </div>
              </div>
              <div class="fullWidth fRow jBetween aStart wrap playList" v-if="isPlaylistGet">
                <h2>لیست ویدئو‌های کلاس {{watchListData.class}}:</h2>
                <div class="fCol fullWidth jStart aStart">
                  <div class="fRow jStart aCenter rh">
                    <i class="material-icons-round">school</i>
                    <div class="teach">مدرس {{watchListData.teacher}}</div>
                  </div>
                  <div class="fRow jStart aCenter rh">
                    <i class="material-icons-round mini">date_range</i>
                    <div class="date">{{watchListData.time}}</div>
                  </div>
                </div>
                <p>برای پخش روی آیتم‌ها کلیک کنید</p>
                <video-item
                  v-for="(item, index) in recordedLink" v-bind:key="item.id"
                  :canDelete="isTeacher"
                  :index="index"
                  :item="item"
                  :url="baseURL"
                  :v="V"
                  @resp="handleDeleteResponse($event)"
                  @deleted="hardRefresh($event)"
                  :roomId="lastRoomId"/>
              </div>
            </div>
            <span class="errorMsg" v-if="reqError">{{reqErrorMsg}}</span>
            <div class="sepSpace"></div>
            <div class="fCol jStart aStart createClassHolder fullWidth" v-if="isTeacher">
              <p>کلاس جدید ایجاد کنید</p>
              <div class="transition-fast fRow jStart aCenter btn new"
                href="#" @click="goToSec('createForm')">
                <i class="material-icons-round">add</i>
                <label>ایجاد کلاس</label>
              </div>
              <div class="fRow fullWidth jStart aStart createTip">
                <h2>نکات ایجاد کلاس جدید</h2>
              </div>
              <div class="fRow fullWidth jStart aStart createTip">
                <i class="material-icons-round">info</i>
                <span>لطفا در وارد کردن اطلاعات کلاس دقت کنید تا از خطاهای احتمالی
                  جلوگیری شود.
                </span>
              </div>
              <div class="fRow fullWidth jStart aStart createTip">
                <i class="material-icons-round">info</i>
                <span>بعد از ایجاد کلاس، مشخصات مخصوص ورود شما پیامک شده و مشخصات
                  مختص ورود دانش‌آموزان نیز قابل اشتراک گذاری می باشد.
                </span>
              </div>
              <div class="fRow fullWidth jStart aStart createTip">
                <i class="material-icons-round">info</i>
                <span>ضمناً حتماً قبل از بستن صفحه از موفقیت‌آمیز بودن اشتراک
                  مشخصات ورود دانش‌آموزان مطمئن شوید. در صورتی که قبل از اشتراک گذاری
                  صفحه بسته یا refresh شد دوباره برای ساخت کلاس اقدام کنید.
                </span>
              </div>
            </div>
          </div>
          <!-- ساختن کلاس -->
          <div class="fCol fullWidth jStart aStart secHolder"
            v-bind:class="{wait: loads}" v-if="createForm && !getStudentInfo">
            <h2>فرم ایجاد کلاس مجازی</h2>
            <p>برای ایجاد کلاس فرم زیر را تکمیل کنید</p>
            <div class="freeSpace fullWidth">
              <div class="f32"></div>
            </div>
            <div class="fRow fullWidth jStart aStart createTip">
              <h3>1. عنوان کلاس را وارد کنید</h3>
            </div>
            <!-- get title -->
            <div class="fRow jStart aCenter fullWidth inputWraper">
              <i class="inputIcon material-icons-round">duo</i>
              <input class="transition-fast" v-model="className"
                placeholder="عنوان کلاس" type="text">
              <radial-progress-bar :diameter="24" class="remainingTime"
                v-bind:style="{marginRight: '8px'}"
                :completed-steps="className.length"
                startColor="var(--primary)"
                stopColor="var(--secondary)"
                innerStrokeColor="var(--normalText15)"
                :animateSpeed='100'
                :innerStrokeWidth="1"
                :strokeWidth="2"
                :total-steps="128">
              </radial-progress-bar>
            </div>
            <div class="fRow fullWidth jStart aStart createTip">
              <h3>2. تاریخ برگزاری کلاس را وارد کنید</h3>
            </div>
            <!-- get date -->
            <div class="fRow jStart aCenter fullWidth inputWraper">
              <custom-date-picker element="date" v-model="date" :min="classTime"/>
              <i class="inputIcon material-icons-round">date_range</i>
              <input class="transition-fast" v-model="datePreview" id="date"
                placeholder="تاریخ برگزاری" type="text" disabled>
            </div>
            <!-- choose server -->
            <div class="fRow fullWidth jStart aStart createTip" v-if="false">
              <h3>3. سرور برگزاری کلاس را انتخاب کنید</h3>
            </div>
            <div class="fRow jStart aCenter fullWidth" v-if="false">
              <div class="fRow jStart aCenter serverItem"
                @click="selectedServer = 1"
                v-bind:class="{selected: selectedServer === 1}">
                <div class="serverIcon bbb"></div>
                <span class="serverName">Big blue button</span>
              </div>
              <div class="fRow jStart aCenter serverItem"
                @click="selectedServer = 2"
                v-bind:class="{selected: selectedServer === 2}">
                <div class="serverIcon ac"></div>
                <span class="serverName">Adobe Connect</span>
              </div>
            </div>
            <span class="errorMsg" v-if="titleError">{{titleErrorMsg}}</span>
            <!-- class available times -->
            <div class="fRow jStart aCenter wrap fullWidth timesHolder">
              <div class="fRow fullWidth jStart aStart createTip">
                <h2>زمان برگزاری کلاس را انتخاب کنید</h2>
              </div>
              <div class="fRow fullWidth jStart aStart createTip">
                <i class="material-icons-round">info</i>
                <span>ابتدا مدت زمان کلاس را انتخاب کنید سپس از بین گزینه‌های فعال
                  زمان برگزاری کلاس را انتخاب کنید.
                </span>
              </div>
              <span class="errorMsg" v-if="classTimeError">{{classTimeErrorMsg}}</span>
              <div class="freeSpace fullWidth">
                <div class="f16"></div>
              </div>
              <div class="fRow fullWidth jStart aStart createTip">
                <h3>2. مدت برگزاری کلاس را انتخاب کنید</h3>
              </div>
              <!-- duration items -->
              <div class="fRow aCenter jStart fullWidth wrap">
                <label class="rContainer checkBoxHolder dark fRow jStart aCenter durSelect"
                  v-if="this.max - this.hour >= 2">
                  <input type="radio"
                    :value="1"
                    v-model="classDurationStep"
                    name="duration"
                    class="parent fullWidth"/>
                  <div class="checkmark dark"></div>
                  <div class="checkText fRow jCenter aCenter">
                    <div>1 ساعت</div>
                  </div>
                </label>
                <label class="rContainer checkBoxHolder dark fRow jStart aCenter durSelect"
                  v-if="this.max - this.hour >= 3">
                  <input type="radio"
                    :value="2"
                    v-model="classDurationStep"
                    name="duration"
                    class="parent fullWidth"/>
                  <div class="checkmark dark"></div>
                  <div class="checkText fRow jCenter aCenter">
                    <div>2 ساعت</div>
                  </div>
                </label>
                <label class="rContainer checkBoxHolder dark fRow jStart aCenter durSelect"
                  v-if="this.max - this.hour >= 4">
                  <input type="radio"
                    :value="3"
                    v-model="classDurationStep"
                    name="duration"
                    class="parent fullWidth"/>
                  <div class="checkmark dark"></div>
                  <div class="checkText fRow jCenter aCenter">
                    <div>3 ساعت</div>
                  </div>
                </label>
              </div>
              <div class="freeSpace fullWidth">
                <div class="f16"></div>
              </div>
              <div class="fRow fullWidth jStart aStart createTip">
                <h3>3. ساعت شروع و پایان کلاس را انتخاب کنید</h3>
              </div>
              <!-- time items ↓ -->
              <div class="fRow wrap fullWidth" v-if="this.max - this.hour >= 2">
                <div class="timeItem fRow jCenter aCenter transition-medium"
                  v-for="(item, index) in classDurationList" v-bind:key="item.id"
                  @click="selectClassDuration(item, index)"
                  v-bind:class="{selected: index === classDurationIndex}">
                  <div class="checkCircle transition-fast"></div>
                  <i class="material-icons-round timer">timelapse</i>
                  <div class="dateInfo growFull fCol jCenter aStart">
                    <div class="fRow fullWidth jStart aCenter s">
                      <span>شروع از {{item.start}}</span>
                    </div>
                    <p class="end">تا ساعت {{item.end}}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- record -->
            <div class="freeSpace fullWidth">
              <div class="f16"></div>
            </div>
            <div class="fRow fullWidth jStart aStart createTip">
              <h3>4. وضعیت ضبط کلاس را انتخاب کنید</h3>
            </div>
            <div class="fRow jStart aCenter inputWraper" @click="toggleRecord">
              <i class="material-icons-round record"
              v-bind:class="{active: haveRecord}">fiber_manual_record</i>
              <label class="growFull" style="margin-left: 8px">ضبط کلاس</label>
              <switch-button activeLabel='فعال' deactiveLabel='غیرفعال' :val='haveRecord' />
            </div>
            <div class="sepSpace"></div>
            <div class="fRow jStart aCenter fullWidth">
              <div class="transition-fast fRow jCenter aCenter btn new growFull"
                href="#" @click="createClass">
                <i class="material-icons-round">done</i>
                <label>ایجاد کلاس</label>
              </div>
              <div class="transition-fast fRow jCenter aCenter btn mini"
                href="#" @click="goToSec('joinForm')"
                style="margin-right: 8px; backgroundColor: #646464">
                <i class="material-icons-round">keyboard_arrow_right</i>
                <label>بازگشت</label>
              </div>
            </div>
            <span class="errorMsg" v-if="reqError">{{reqErrorMsg}}</span>
            <!-- <i class="material-icons-round fab fRow jCenter aCenter transition-fast"
              v-bind:class="{ready: true}"
              @click='joinClass'>add</i> -->
          </div>
          <!-- پایان ساخت کلاس -->
          <div class="fCol fullWidth jStart aStart secHolder"
            v-bind:class="{wait: loads}" v-if="classCreated && !getStudentInfo">
            <h2>بررسی و ثبت نهایی</h2>
            <p>قبل از ثبت اطلاعات کلاس درستی آن‌ها را بررسی کنید</p>
            <div class="sepSpace"></div>
            <div class="review cn">کلاس {{className}}</div>
            <div class="review ct">مدرس: {{classTeacher}}</div>
            <div class="review cd">تاریخ برگزاری: {{datePreview}}</div>
            <div class="review cd">مدت زمان کلاس: {{classDurationStep * 60}} دقیقه<br>
              (از ساعت {{classStartAt.substr(0,5)}} تا {{classEndAt.substr(0,5)}})</div>
            <div class="review cId">شناسه‌ی کلاس: <span class="inline">{{classId}}</span></div>
            <div class="review cTpass" v-if="false">گذرواژه‌ی مدرس:
              <span class="inline">{{classTeacherPass}}</span></div>
            <div class="review cTpass">گذرواژه‌ی دانش‌آموز:
              <span class="inline">{{classStudentPass}}</span></div>
            <div class="freeSpace">
              <div class="f16"></div>
            </div>
            <div class="fRow fullWidth jStart aStart createTip">
              <h2>قبل از ثبت کلاس به نکات زیر دقت کنید:</h2>
            </div>
            <div class="fRow fullWidth jStart aStart createTip">
              <i class="material-icons-round">info</i>
              <span>شناسه کلاس و گذرواژه به صورت اتوماتیک ساخته می‌شوند
                و شما امکان ویرایش آن را ندارید. بعد از ثبت کلاس حتما
                مشخصات کلاس را از طریق تلگرام یا واتسپ با دانش‌آموزان به اشتراک بگذارید.
              </span>
            </div>
            <div class="fRow fullWidth jStart aStart createTip">
              <i class="material-icons-round">info</i>
              <span>شناسه کلاس و گذرواژه مخصوص شما برایتان پیامک خواهد شد.
                توجه فرمایید که در صورت استفاده از گذرواژه‌ی دانش‌آموز امکانات اصلی کلاس را
                در اختیار نخواهید داشت.</span>
            </div>
            <div class="fRow fullWidth jStart aStart createTip">
              <i class="material-icons-round">info</i>
              <span>در صورت نیاز به ویرایش ساعت و عنوان کلاس گزینه "ویرایش" را
                انتخاب کنید. در غیر صورت برای ثبت کلاس اقدام کنید</span>
            </div>
            <div class="freeSpace">
              <div class="f16"></div>
            </div>
            <div class="fRow jStart aCenter fullWidth">
              <div class="transition-fast fRow jCenter aCenter btn new growFull"
                href="#" @click="createClassRequest">
                <i class="material-icons-round">add_task</i>
                <label>ثبت نهـایی</label>
              </div>
              <div class="transition-fast fRow jCenter aCenter btn mini"
                href="#" @click="goToSec('createForm')"
                style="margin-right: 8px; backgroundColor: #646464">
                <i class="material-icons-round">edit</i>
                <label>ویرایش</label>
              </div>
            </div>
            <span class="errorMsg" v-if="reqError">{{reqErrorMsg}}</span>
            <!-- <i class="material-icons-round fab fRow jCenter aCenter transition-fast"
              v-bind:class="{ready: true}"
              @click='joinClass'>add</i> -->
            <!-- ooooooooooo -->
          </div>
        </div>
        <div class="fixed animationHolder fCol jCenter aCenter">
          <lottie-animation
            path="./animations/animation.json"
            :loop="true"
            :autoPlay="true"
            :width="animSize.w"
            :height="animSize.h"/>
        </div>
        <!-- <lottie-player src="https://assets4.lottiefiles.com/private_files/lf30_TBKozE.json" background="transparent"
          speed="1" @load="init" class="animBig" autoplay loop></lottie-player> -->
        <div class="fRow jEnd aCenter mZadak">
          <div class="zadakLabel">Developed by<br><a href="https://zadak.ir">Z A D A K</a></div>
          <div class="zadakLogo"></div>
        </div>
      </div>
    </keep-alive>
    <radial-progress-bar :diameter="48" v-if="false"
      :completed-steps="completedSteps"
      startColor="var(--primary)"
      stopColor="var(--secondary)"
      innerStrokeColor="var(--normalText15)"
      :animateSpeed='100'
      :innerStrokeWidth="2"
      :strokeWidth="4"
      :total-steps="totalSteps">
      <p class="remaining">{{this.completedSteps}}</p>
    </radial-progress-bar>
  </div>
</template>

<script>
// @ is an alias to /src
import RadialProgressBar from 'vue-radial-progress';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
import SwitchButton from '@/components/SwitchButton.vue';
import Toast from '@/components/Toast.vue';
import VideoItem from '@/components/VideoItem.vue';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import moment from 'moment-jalaali';
import axios from 'axios';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  mixins: [errorHandler, makeToast],
  name: 'Home',
  components: {
    RadialProgressBar,
    LottieAnimation,
    SwitchButton,
    Toast,
    VideoItem,
  },
  data() {
    return {
      V: 1,
      osDetected: this.$store.state.os,
      isChrome: false,
      isSafari: false,
      ip: '',
      canDelete: false,
      deleteDialog: false,
      joinClassMode: true,
      selectedServer: 1,
      watchListData: {
        class: '',
        teacher: '',
        date: '',
        time: '',
      },
      joinClassData: {
        class: '',
        teacher: '',
        date: '',
        time: '',
      },
      reqError: false,
      goToAssignment: false,
      reqErrorMsg: '',
      titleError: false,
      titleErrorMsg: 'لطفا یک عنوان برای کلاس وارد کنید. مثلاً: «شیمی پایه‌ی دوازدهم - جلسه‌ی سوم»',
      classTimeError: false,
      classTimeErrorMsg: 'لطفا زمان برگزاری کلاس را از بین گزینه‌های فعال انتخاب کنید',
      notIran: false,
      currentCountry: '',
      documentLoad: false,
      loads: false,
      userType: 1,
      verifyId: '',
      arrowPos: 'calc(75% - 12px)',
      completedSteps: 5,
      totalSteps: 10,
      timerInterval: null,
      token: '',
      fp: '',
      classDate: '',
      date: '',
      datePreview: '',
      classTime: '',
      classTimeToShow: '',
      classStartAt: '',
      classStartAtToShow: '',
      classEndAt: '',
      classEndAtToShow: '',
      className: '',
      classTeacher: '',
      classId: '',
      classTeacherPass: '',
      classStudentPass: '',
      classDuration: 0,
      durationError: false,
      classDesc: '',
      classTotal: '',
      readyToShare: false,
      today: '',
      todayPersian: '',
      isJoinedClass: false,
      isPlaylistGet: false,
      classLink: '',
      recordedLink: '',
      // createClassValidation
      ccv: {
        name: false,
        date: false,
        duration: false,
        start: false,
        end: false,
      },
      screen: {
        w: 0,
        h: 0,
      },
      userDropDown: false,
      haveRecord: true,
      loggedIn: false,
      userName: '',
      userAvatar: '',
      isTeacher: false,
      userFirstName: '',
      userLastName: '',
      getStudentInfo: false,
      animSize: {},
      // from old source
      phone: '',
      verifyCode: '',
      roomId: '',
      lastRoomId: '',
      lastRoomIdJoin: '',
      secs: 180,
      secsRem: 0,
      roomPassword: '',
      message: 'Hello Vue!',
      getPhone: true,
      getVerification: false,
      joinForm: false,
      createForm: false,
      classCreated: false,
      hour: 0,
      min: 0,
      max: 0,
      // load datas
      motionLoad: false,
      // page handle data
      activePage: 'phone',
      isClass: false,
      isShareScreen: false,
      classDurationStep: 0,
      classDurationList: [],
      classDurationSelected: {},
      classDurationIndex: -1,
      outOfTime: false,
      // app options
      micMute: true,
      studentList: false,
      openListFlag: false,
      classAvatar: 'img/fizik.jpg',
      teacherAvatar: 'img/teacher.jpg',
      teacherName: 'مهدی کاظمیان',
      teacherScore: 5,
      classGradeField: 'پایه دوم تجربی',
      // n
      hasAvatar: false,
      isClassForToday: true,
    };
  },
  methods: {
    handleDeleteResponse(event) {
      this.reqError = true;
      this.reqErrorMsg = event;
    },
    hardRefresh() {
      // console.log('hard');
      this.watchClassRequest();
    },
    getOs() {
      const [userAgent] = [window.navigator.userAgent];
      const [platform] = [window.navigator.platform];
      const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
      const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
      const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
      let os = null;

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
      } else if (/Android/.test(userAgent)) {
        os = 'Android';
      } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
      }
      return os;
    },
    stopTimer() {
      clearInterval(this.timerInterval);
      this.$store.commit('zeroTimer');
      this.$store.commit('TimerFalse');
    },
    startTimer() {
      if (this.$store.state.globalTimer !== this.secs) {
        this.$store.commit('resetTimer');
      }
      this.timerInterval = setInterval(() => {
        this.$store.commit('TimerTrue');
        this.$store.commit('timerDown');
        if (this.$store.state.globalTimer === 0) {
          this.stopTimer();
          this.$store.commit('TimerFalse');
        }
      }, 1000);
    },
    activeGetPhone() {
      this.getPhone = true;
      this.getVerification = false;
      this.joinForm = false;
      clearInterval(this.timerInterval);
      this.secsRem = this.secs;
      this.loggedIn = false;
      this.userDropDown = false;
      this.phone = '';
      this.verifyCode = '';
    },
    activeGetVerification() {
      if (this.phoneIsReady) {
        this.getPhone = false;
        this.getVerification = true;
        this.joinForm = false;
        this.secsRem = this.secs;
        this.loggedIn = false;
        this.userDropDown = false;
        // alert(this.secsRem);
        // this.timerInterval = setInterval(() => {
        //   this.secsRem -= 1;
        //   if (this.secsRem === 0) {
        //     clearInterval(this.timerInterval);
        //   }
        // }, 1000);
      }
    },
    activeJoinForm() {
      if (this.codeIsReady || this.loggedIn) {
        this.userDropDown = false;
        this.getPhone = false;
        this.getVerification = false;
        this.joinForm = true;
        this.loggedIn = true;
      }
    },
    goToSec(sec) {
      this.reqError = false;
      this.getPhone = false;
      this.getVerification = false;
      this.joinForm = false;
      this.createForm = false;
      this.isClass = false;
      this.classCreated = false;
      this.scrollToTop();
      switch (sec) {
        case 'phone': {
          this.getPhone = true;
          break;
        }
        case 'verify': {
          this.getVerification = true;
          break;
        }
        case 'joinForm': {
          this.joinForm = true;
          this.scrollToTop();
          break;
        }
        case 'createForm': {
          if (this.max - this.hour === 1) {
            this.goToSec('joinForm');
            this.makeToast('error', 'در حال حاضر امکان ایجاد کلاس جدید وجود ندارد', 3000);
          } else {
            this.createForm = true;
          }
          break;
        }
        case 'classCreated': {
          this.classCreated = true;
          break;
        }
        case 'class': {
          this.isClass = true;
          break;
        }
        default:
          break;
      }
    },
    init() {
      setTimeout(() => {
        if (this.loggedIn) {
          const u = this.$jwt.decode(JSON.parse(localStorage.getItem('user')));
          this.isTeacher = u.UserType !== 'Students';
          this.$store.commit('setIsTeacher', this.isTeacher);
          console.warn(this.isTeacher);
          if (true) {
            // اینجا باید پروفایل رو صدا بزنیم و بقیه‌ی ماجرا
            axios({
              method: 'get',
              url: `${this.baseURL}/api/v${this.V}/Members/profile`,
              headers: {
                Authorization: `bearer ${localStorage.getItem('user').replace(/"/g, '')}`,
              },
              data: {
              },
            }).then(
              (response) => {
                if (response.data.isSuccess) {
                  console.log(response.data.data);
                  const r = response.data.data;
                  // continue...
                  if (this.isTeacher) {
                    // this.userAvatar = 'https://class.rimik.ir/media/noteacher.svg';
                    // handle when user is teacher
                  }
                  // set Avatar
                  if (r.avatar === null) {
                    this.hasAvatar = false;
                  } else {
                    this.hasAvatar = true;
                    this.userAvatar = `https://api.rimik.ir/${r.avatar}`;
                  }
                  this.userName = r.fullName;
                  this.classTeacher = r.fullName;
                  this.classTeacherPass = this.generatePassword('t', 6);
                  this.classStudentPass = this.generatePassword('s', 6);
                  this.classId = this.generatePassword('ri', 7);
                }
              },
              (error) => {
                // error
                this.makeToast('error', this.errorHandler(error), 3000);
              },
            ).catch(() => {
              // eslint-disable-next-line
              this.makeToast('catch', 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید', 6000);
            });
          }
        }
        setTimeout(() => {
          this.documentLoad = true;
        }, 1500);
      }, 2000);
    },
    toggleRecord() {
      this.haveRecord = !this.haveRecord;
    },
    toggleUserDropDown() {
      this.userDropDown = !this.userDropDown;
    },
    // cir = codeIsReady
    cir() {
      let tempCode = this.verifyCode.toString();
      const codePattern = /^\d{6}$/;
      if (tempCode.match(codePattern)) {
        return true;
      }
      if (tempCode.length > 6) {
        tempCode = tempCode.substr(0, 6);
        this.verifyCode = parseInt(tempCode, 10);
        return true;
      }
      return false;
    },
    // pir = phoneIsReady
    pir() {
      const phonePattern = /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
      // eslint-disable-next-line
      const cond = this.phone.toString().match(phonePattern) && (this.phone.toString().charAt(0) === '0' && this.phone.toString().charAt(1) === '9');
      if (cond) {
        return true;
        // eslint-disable-next-line
      } else if (this.phone.length > 11) {
        this.fitTo('phone');
        return true;
      }
      return false;
    },
    getWindowWidth() {
      this.screen.w = document.documentElement.clientWidth;
      this.animSize = this.lottieSize();
    },
    getWindowHeight() {
      this.screen.h = document.documentElement.clientHeight;
      this.animSize = this.lottieSize();
    },
    // calculate and return animation w / h
    lottieSize() {
      const sizes = {
        w: 0,
        h: 0,
        portrait: true,
      };
      if (this.screen.w > this.screen.h) {
        sizes.portrait = false;
        // alert(sizes.portrait);
      }
      sizes.w = (this.screen.h / 15) * 2;
      sizes.h = (this.screen.h / 15) * 2;
      return sizes;
    },
    toggleUserType(type) {
      switch (type) {
        case 'teacher': {
          this.userType = 2;
          this.arrowPos = 'calc(25% - 12px)';
          break;
        }
        case 'student': {
          this.userType = 1;
          this.arrowPos = 'calc(75% - 12px)';
          break;
        }
        default:
          break;
      }
    },
    toggleJoinClass(type) {
      this.roomId = '';
      this.roomPassword = '';
      this.reqError = false;
      switch (type) {
        case 'join': {
          this.roomId = this.lastRoomIdJoin;
          this.joinClassMode = true;
          this.arrowPos = 'calc(75% - 12px)';
          break;
        }
        case 'record': {
          if (this.isJoinedClass) {
            this.reqError = true;
            this.reqErrorMsg = 'برای مشاهده‌ی کلاس‌های قبلی، ابتدا از کلاس فعلی خارج شوید';
          } else {
            this.roomId = this.lastRoomId;
            this.joinClassMode = false;
            this.arrowPos = 'calc(25% - 12px)';
          }
          break;
        }
        default:
          break;
      }
    },
    // send register
    registerRequest() {
      if (this.phoneIsReady) {
        this.loads = true;
        let correctPhone = this.phone.substring(1);
        correctPhone = `98${correctPhone}`;
        axios({
          method: 'post',
          url: `${this.baseURL}/api/v${this.V}/Members/register`,
          headers: {
            isClass: true,
          },
          data: {
            phoneNumber: correctPhone,
            // type: this.userType,
          },
        }).then(
          (response) => {
            if (response.data.isSuccess) {
              this.reqError = false;
              this.goToAssignment = false;
              this.verifyId = response.data.data;
              this.loads = false;
              if (response.data.message.includes('شده است') && !this.$store.state.isTimer) {
                this.stopTimer();
                this.activeGetVerification();
              } else if (response.data.message.includes('شده است') && this.$store.state.isTimer) {
                this.activeGetVerification();
              } else {
                this.startTimer();
                this.activeGetVerification();
              }
              this.makeToast('success', response.data.message, 3000);
            } else {
              this.loads = false;
              this.reqError = true;
              this.reqErrorMsg = response.data.message;
              this.goToAssignment = true;
              this.makeToast('warning', response.data.message, 3000);
              // error
            }
          },
          (error) => {
            // error
            this.makeToast('error', this.errorHandler(error), 3000);
            this.reqError = true;
            this.reqErrorMsg = this.errorHandler(error);
            this.loads = false;
          },
        ).catch(() => {
          // eslint-disable-next-line
          this.loads = false;
          this.makeToast('catch', 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید', 4000);
          this.reqError = true;
          this.reqErrorMsg = 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید';
        });
      } else {
        this.reqError = true;
        this.reqErrorMsg = 'لطفا شماره را به درستی وارد کنید';
        this.makeToast('warning', 'لطفا شماره را به درستی وارد کنید', 2500);
      }
    },
    // verify register
    verifyRequest() {
      if (this.codeIsReady) {
        this.loads = true;
        axios({
          method: 'post',
          url: `${this.baseURL}/api/v${this.V}/Members/verify`,
          headers: {
            Domain: 'rimik.ir',
          },
          data: {
            verificationId: this.verifyId,
            fingerprint: this.fp,
            code: parseInt(this.verifyCode, 10),
            // classApp: true,
          },
        }).then(
          (response) => {
            if (response.data.isSuccess) {
              this.reqError = false;
              this.token = response.data.data;
              localStorage.setItem('user', JSON.stringify(this.token));
              const n = this.$jwt.decode(response.data.data);
              if (n.FullName === '') {
                this.showUpdateProfile();
              } else {
                localStorage.setItem('userFullName', '');
                this.$router.go();
              }
            } else {
              this.loads = false;
              this.reqError = true;
              this.reqErrorMsg = response.data.message;
              this.makeToast('warning', response.data.message, 3000);
              // error
            }
          },
          (error) => {
            // error
            this.makeToast('error', this.errorHandler(error), 3000);
            this.reqError = true;
            this.reqErrorMsg = this.errorHandler(error);
            this.loads = false;
          },
        ).catch(() => {
          // eslint-disable-next-line
          this.loads = false;
          this.makeToast('catch', 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید', 6000);
          this.reqError = true;
          this.reqErrorMsg = 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید';
        });
      } else {
        this.reqError = true;
        this.reqErrorMsg = 'کد 6 رقمی را وارد کنید';
      }
    },
    showUpdateProfile() {
      this.getStudentInfo = true;
    },
    updateProfile() {
      if (this.userFirstName.length > 2 && this.userLastName.length > 2) {
        axios({
          method: 'post',
          url: `${this.baseURL}/api/v${this.V}/Accounts/profile`,
          headers: {
            Authorization: `bearer ${localStorage.getItem('user').replace(/"/g, '')}`,
          },
          data: {
            FirstName: this.userFirstName,
            LastName: this.userLastName,
          },
        }).then(
          (response) => {
            if (response.data.isSuccess) {
              localStorage.setItem('userFullName', `${this.userFirstName} ${this.userLastName}`);
              this.$router.go();
            } else {
              this.loads = false;
              this.reqError = true;
              this.reqErrorMsg = response.data.message;
              this.makeToast('warning', response.data.message, 3000);
              // error
            }
          },
          (error) => {
            // error
            this.makeToast('error', this.errorHandler(error), 3000);
            this.reqError = true;
            this.reqErrorMsg = this.errorHandler(error);
            this.loads = false;
          },
        ).catch(() => {
          // eslint-disable-next-line
          this.loads = false;
          this.reqError = true;
          this.reqErrorMsg = 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید';
          this.makeToast('catch', 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید', 4000);
        });
      } else {
        this.reqError = true;
        this.reqErrorMsg = 'نام و نام خانوادگی را وارد کنید';
        this.makeToast('warning', 'نام و نام خانوادگی را وارد کنید', 3000);
      }
    },
    // errorHandler(err) {
    //   if (err.response.status === 401) {
    //     localStorage.removeItem('user');
    //     localStorage.removeItem('userFullName');
    //     this.$router.go();
    //   } else {
    //     this.errorHandler
    //   }
    // },
    // create class
    createClassRequest() {
      this.loads = true;
      this.classTime = this.date;
      const finalStart = `${this.classTime}${this.classStartAt}`;
      const finalEnd = `${this.classTime}${this.classEndAt}`;
      if (true) {
        axios({
          method: 'post',
          url: `${this.baseURL}/api/v${this.V}/Classes/create`,
          headers: {
            Authorization: `bearer ${localStorage.getItem('user').replace(/"/g, '')}`,
          },
          data: {
            Name: this.className,
            MeetingId: this.classId,
            AttendeePassword: this.classStudentPass,
            ModeratorPassword: this.classTeacherPass,
            StartAt: finalStart,
            EndDate: finalEnd,
            Record: this.haveRecord,
            Duration: this.classDurationStep * 60,
            lessonId: '61c30a3cfe0f7ab0e48c720c',
            status: true,
            type: 2,
          },
        }).then(
          (response) => {
            if (response.data.isSuccess) {
              this.reqError = false;
              this.loads = false;
              this.shareIt();
            } else {
              this.loads = false;
              this.reqError = true;
              this.reqErrorMsg = response.data.message;
              this.makeToast('warning', response.data.message, 3000);
              // error
            }
          },
          (error) => {
            // error
            this.makeToast('error', this.errorHandler(error), 3000);
            this.reqError = true;
            this.reqErrorMsg = this.errorHandler(error);
            this.loads = false;
          },
        ).catch(() => {
          // eslint-disable-next-line
          this.loads = false;
          this.reqError = true;
          this.reqErrorMsg = 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید';
          this.makeToast('catch', 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید', 4000);
        });
      }
    },
    // join class
    joinValidation() {
      return this.roomIdIsReady && this.roomPasswordIsReady;
    },
    joinClass() {
      if (this.joinValidation()) {
        this.JoinClassRequest();
      } else {
        this.reqError = true;
        this.reqErrorMsg = 'آیدی و رمز ورود به کلاس را بررسی کنید';
        this.makeToast('warning', 'آیدی و رمز ورود به کلاس را بررسی کنید', 2500);
      }
    },
    JoinClassRequest() {
      this.loads = true;
      axios({
        method: 'post',
        url: `${this.baseURL}/api/v${this.V}/Classes/join`,
        headers: {
          Authorization: `bearer ${localStorage.getItem('user').replace(/"/g, '')}`,
        },
        data: {
          MeetingId: this.roomId,
          Password: this.roomPassword,
        },
      }).then(
        (response) => {
          if (response.data.isSuccess) {
            this.loads = false;
            this.reqError = false;
            this.lastRoomIdJoin = this.roomId;
            this.isJoinedClass = true;
            this.joinClassData.teacher = response.data.data.teacher;
            let sdate = response.data.data.startAt;
            let edate = response.data.data.endAt;
            sdate = sdate.split('T');
            edate = edate.split('T');
            // eslint-disable-next-line
            this.joinClassData.time = `کلاس همین حالا در حال برگزاری است (${sdate[1].substr(0, 5)} تا ${edate[1].substr(0, 5)})`;
            this.joinClassData.class = response.data.data.class;
            // joinClassData
            this.classLink = response.data.data.url;
            // this.openClass();
          } else {
            this.loads = false;
            // alert(response.data.message);
            this.reqError = true;
            this.reqErrorMsg = response.data.message;
            this.makeToast('warning', response.data.message, 3000);
            // error
          }
        },
        (error) => {
          // error
          this.makeToast('error', this.errorHandler(error), 3000);
          this.reqError = true;
          this.reqErrorMsg = this.errorHandler(error);
          this.loads = false;
        },
      ).catch(() => {
        // eslint-disable-next-line
        this.loads = false;
        this.reqError = true;
        this.reqErrorMsg = 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید';
        this.makeToast('catch', 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید', 4000);
      });
    },
    watchClassRequest() {
      if (this.roomId.length === 9) {
        this.loads = true;
        this.reqError = false;
        this.recordedLink = '';
        axios({
          method: 'get',
          url: `${this.baseURL}/api/v${this.V}/Rooms/record/${this.roomId}`,
          headers: {
            Authorization: `bearer ${localStorage.getItem('user').replace(/"/g, '')}`,
          },
          data: {
            MeetingId: this.roomId,
          },
        }).then(
          (response) => {
            if (response.data.isSuccess) {
              // console.log('refresh shod');
              this.loads = false;
              this.reqError = false;
              this.lastRoomId = this.roomId;
              this.canDelete = response.data.data.isDelete;
              this.recordedLink = response.data.data.videos;
              this.watchListData.teacher = response.data.data.teacher;
              this.watchListData.class = response.data.data.class;
              // inja bayad tarikh ro joda konim
              let sdate = response.data.data.startAt;
              let edate = response.data.data.endAt;
              sdate = sdate.split('T');
              edate = edate.split('T');
              // eslint-disable-next-line
              this.watchListData.time = moment(sdate[0], 'YYYY-MM-DDT').locale('fa').format('jDD jMMMM jYYYY');
              this.watchListData.time += `، ساعت ${sdate[1].substr(0, 5)} تا ${edate[1].substr(0, 5)}`;
              this.isPlaylistGet = true;
              // this.openRecord();
            } else {
              this.loads = false;
              this.reqError = true;
              this.reqErrorMsg = response.data.message;
              this.makeToast('warning', response.data.message, 3000);
            }
          },
          (error) => {
            // error
            this.makeToast('error', this.errorHandler(error), 3000);
            this.reqError = true;
            this.reqErrorMsg = this.errorHandler(error);
            this.loads = false;
          },
        ).catch(() => {
          // eslint-disable-next-line
          this.loads = false;
          this.reqError = true;
          this.reqErrorMsg = 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید';
          this.makeToast('catch', 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید', 4000);
        });
      } else {
        this.reqError = true;
        this.reqErrorMsg = 'طول شناسه‌ی کلاس باید 9 کاراکتر باشد';
      }
    },
    openClass() {
      window.open(this.classLink);
      this.$refs.exit.click();
    },
    openRecord() {
      window.open(this.recordedLink);
    },
    scrollToTop() {
      this.$refs.content.scrollTop = 0;
    },
    logOut() {
      localStorage.removeItem('user');
      localStorage.removeItem('userFullName');
      this.$router.go();
    },
    generatePassword(pre, len) {
      let p = `${pre}`;
      for (let i = 1; i <= len; i += 1) {
        if (i % 3 !== 0) {
          p += Math.floor(Math.random() * (9 - 0 + 1) + 0);
        } else {
          p += String.fromCharCode(Math.floor(Math.random() * (122 - 97 + 1) + 97));
        }
      }
      return p;
    },
    createFormValidation() {
      this.ccv.name = this.className !== '';
      this.ccv.date = this.classDurationIndex !== -1;
      if (!this.ccv.name) {
        this.titleError = true;
        this.scrollToTop();
        this.makeToast('error', 'عنوان کلاس را وارد کنید', 3000);
      } else {
        this.titleError = false;
      }
      if (!this.ccv.date) {
        this.classTimeError = true;
        this.scrollToTop();
      } else {
        this.classTimeError = false;
      }
      return this.ccv.name && this.ccv.date;
    },
    createClass() {
      if (this.createFormValidation()) {
        this.scrollToTop();
        this.classCreated = true;
        this.createForm = false;
        this.reqError = false;
      }
    },
    copyDesc() {
      const tarea = this.$refs.total;
      tarea.select();
      tarea.setSelectionRange(0, 99999);
      document.execCommand('copy');
      tarea.blur();
      this.makeToast('error', 'اطلاعات کلاس در حافظه کپی شد', 3000);
    },
    refresh() {
      this.$router.go();
      // window.open('https://www.w3schools.com');
    },
    shareIt() {
      this.readyToShare = true;
    },
    yourCallBackFunction() {
      // alert('hey');
    },
    // create class req temps
    computeAvailableTimes() {
      this.today = new Date();
      let hour = 7;
      if (this.isClassForToday) {
        hour = this.today.getHours();
      }
      const minutes = this.today.getMinutes();
      this.hour = hour;
      const firstAvailableHour = hour + 1;
      const min = 7;
      this.min = min;
      const max = 23;
      this.max = max;
      const classArray = [];
      let classObject = {};
      // const format = 'hh:mm:ss';
      // const bbb = moment('07:00:00', format);
      // const aaa = moment('23:59:59', format);
      // const ttt = moment('15:59:59', format);
      // alert(moment(ttt).isBetween(aaa, bbb));
      // const ttt = moment().format(format);
      const isBetween = (hour <= max || (hour === max && minutes < 59)) && hour >= min;
      if (isBetween) {
        this.outOfTime = false;
        let i = firstAvailableHour;
        let tempi = i;
        while (i + this.classDurationStep <= max) {
          classObject = { start: 0, end: 0 };
          classObject.start = i;
          i += this.classDurationStep;
          classObject.end = i;
          tempi += 1;
          i = tempi;
          classArray.push(classObject);
        }
        this.classDurationList = classArray;
      } else {
        this.outOfTime = true;
      }
    },
    selectClassDuration(item, ind) {
      this.classDurationSelected = item;
      this.classDurationIndex = ind;
      if (item.start < 10) {
        this.classStartAt = `0${item.start}:00:00`;
      } else {
        this.classStartAt = `${item.start}:00:00`;
      }
      if (item.end < 10) {
        this.classEndAt = `0${item.end}:00:00`;
      } else {
        this.classEndAt = `${item.end}:00:00`;
      }
    },
    checkChrome() {
      const a = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
      // Safari 3.0+ "[object HTMLElementConstructor]"
      // eslint-disable-next-line
      this.isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
      // const b = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
      this.isChrome = a;
    },
    fitTo(str) {
      switch (str) {
        case 'id': {
          // id
          this.roomId = this.roomId.substr(0, 9);
          break;
        }
        case 'pas': {
          // pass
          this.roomPassword = this.roomPassword.substr(0, 8);
          break;
        }
        case 'phone': {
          // phone
          this.phone = this.phone.substr(0, 11);
          break;
        }
        default:
          break;
      }
    },
    // room id is ready
    riir() {
      const patt = RegExp('^[a-z0-9_]*$');
      if (this.roomId.length <= 9
        && this.roomId.length > 0
        && patt.test(this.roomId.toLowerCase())) {
        return true;
      }
      if (this.roomId.length > 9) {
        this.fitTo('id');
        return true;
      }
      return false;
    },
    // room password is ready
    rpir() {
      const patt = RegExp('^[a-z0-9_]*$');
      if (this.roomPassword.length <= 8
        && this.roomPassword.length > 0
        && patt.test(this.roomPassword.toLowerCase())) {
        return true;
      }
      if (this.roomPassword.length > 8) {
        this.fitTo('pas');
        return true;
      }
      return false;
    },
    goToClasses() {
      this.$router.push('/classes');
    },
  },
  computed: {
    appName() {
      return this.$store.state.appName;
    },
    baseURL() {
      return this.$store.state.appName.url;
    },
    webShareApiSupported() {
      return navigator.share;
    },
    codeIsReady() {
      return this.cir();
    },
    phoneIsReady() {
      return this.pir();
    },
    studentsLen() {
      return this.students.lenght;
    },
    classMode() {
      return this.isClass;
    },
    roomPasswordIsReady() {
      return this.rpir();
    },
    roomIdIsReady() {
      return this.riir();
    },
    waitForRecode() {
      return (this.$store.state.globalTimer / this.secs) * 50;
    },
    elementLoad() {
      if (this.motionLoad) {
        return true;
      }
      return false;
    },
    secToMin() {
      let m = Math.floor(this.secsRem / 60);
      if (m < 10) {
        m = `0${m}`;
      } else {
        m = `${m}`;
      }
      let s = this.secsRem % 60;
      if (s < 10) {
        s = `0${s}`;
      } else {
        s = `${s}`;
      }
      return `${m}:${s}`;
    },
    secToMinTimer() {
      let m = Math.floor(this.$store.state.globalTimer / 60);
      if (m < 10) {
        m = `0${m}`;
      } else {
        m = `${m}`;
      }
      let s = this.$store.state.globalTimer % 60;
      if (s < 10) {
        s = `0${s}`;
      } else {
        s = `${s}`;
      }
      return `${m}:${s}`;
    },
    computedDesc() {
      let t = `🎓 مدرس: ${this.classTeacher}\n⏰ ${this.datePreview}\n`;
      // eslint-disable-next-line
      t += `⌛️ به مدت ${this.classDurationStep * 60} دقیقه (از ساعت ${this.classStartAt.substr(0,5)} تا ${this.classEndAt.substr(0,5)})`;
      t += '\n\n▬▬▬ مشخصات ورود به کلاس ▬▬▬\n';
      t += `🔗 لینک ورود: ${this.appName.home} \n`;
      t += `🔹 شناسه‌ی کلاس: ${this.classId}\n🔸 گذرواژه: ${this.classStudentPass}\n\n`;
      // this.classDesc = t;
      return t;
    },
  },
  watch: {
    classDurationStep() {
      this.classDurationIndex = -1;
      this.computeAvailableTimes();
    },
    secsRem() {
      if (this.secsRem === 0) {
        // alert(this.secsRem);
        clearInterval(this.timerInterval);
      }
    },
    computedDesc() {
      this.classTotal = `🔖 ${this.className}\n${this.computedDesc}`;
    },
    userFirstName() {
      if (this.userFirstName.length > 35) {
        this.userFirstName = this.userFirstName.substr(0, 35);
      }
    },
    userLastName() {
      if (this.userLastName.length > 50) {
        this.userLastName = this.userLastName.substr(0, 50);
      }
    },
    className() {
      if (this.className.length > 128) {
        this.className = this.className.substr(0, 128);
      }
    },
    classTime() {
    },
    createForm() {
      this.scrollToTop();
    },
    date() {
      const today = moment(this.today).format('YYYY-MM-DDT');
      this.isClassForToday = this.date === today;
      console.log(this.date, today);
      this.computeAvailableTimes();
      console.log('isClassForToday', this.isClassForToday);
      this.datePreview = moment(this.date, 'YYYY-MM-DDT')
        .format('dddd jDD jMMMM jYYYY');
    },
  },
  mounted() {
    this.$nextTick(() => {
      console.clear();
      console.log(this.baseURL);
      // eslint-disable-next-line
      fetch('https://api.ipify.org?format=json')
        .then((x) => x.json())
        .then(({ ip }) => {
          this.ip = ip;
          axios({
            method: 'get',
            url: `${this.baseURL}/api/v${this.V}/Utils/location/${ip}`,
          }).then(
            (response) => {
              this.currentCountry = JSON.parse(response.data.data).geoplugin_countryName;
              // alert(this.currentCountry);
              if (this.currentCountry !== 'Iran') {
                this.notIran = true;
              }
            },
            (error) => {
              // error
              this.makeToast('error', this.errorHandler(error), 3000);
              this.loads = false;
            },
          ).catch(() => {
            // eslint-disable-next-line
            this.loads = false;
            this.makeToast('catch', 'مشکلی پیش آمده است، اتصال به اینترنت را بررسی کنید', 4000);
          });
        });
      this.osDetected = this.getOs();
      this.checkChrome();
      // این فقط رو کروم کار کرد
      window.addEventListener('load', () => {
        window.history.pushState({ noBackExitsApp: true }, '');
      });
      window.addEventListener('popstate', (event) => {
        if (event.state && event.state.noBackExitsApp) {
          window.history.pushState({ noBackExitsApp: true }, '');
        }
      });
      // window.addEventListener('backbutton', this.yourCallBackFunction, false);
      if (localStorage.getItem('user') !== null) {
        const u = this.$jwt.decode(JSON.parse(localStorage.getItem('user')));
        const isExpired = Date.now() > u.exp * 1000;
        if (!isExpired) {
          this.loggedIn = true;
          this.activePage = 'joinForm';
          this.init();
          this.activeJoinForm();
        } else {
          localStorage.removeItem('user');
          localStorage.removeItem('userFullName');
          this.$router.go();
        }
      } else {
        (async () => {
          const fp = await FingerprintJS.load();
          const result = await fp.get();
          const [visitorId] = [result.visitorId];
          this.fp = visitorId;
          this.init();
        })();
        this.$nextTick(() => {
          window.addEventListener('resize', this.getWindowWidth);
          window.addEventListener('resize', this.getWindowHeight);
          // Init
          this.getWindowWidth();
          this.getWindowHeight();
        });
      }
      this.computeAvailableTimes();
      this.classTime = moment(new Date()).format('YYYY-MM-DDT');
      this.date = this.classTime;
      this.todayPersian = moment(new Date()).format('امروز، dddd jDD jMMMM jYYYY');
      this.classDurationStep = 1;
    });
  },
  beforeDestroy() {
    // window.addEventListener('backbutton', this.yourCallBackFunction, false);
  },
};
</script>

<style lang='scss' scoped >
  .noContent{
    padding: 164px 0;
    font-weight: 100;
    letter-spacing: 4px;
    font-size: 24px;
  }
  .serverItem {
    padding: 8px 8px 8px 16px;
    border-radius: 24px;
    margin-left: 4px;
    cursor: pointer;
    background-color: var(--normalText15);
    border: solid 2px var(--primary);
    * {
      pointer-events: none;
    }
    .serverIcon {
      width: 32px;
      height: 32px;
      margin-left: 8px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
    .serverIcon.bbb {
      background-image: url('~@/assets/bbb.png');
    }
    .serverIcon.ac {
      background-image: url('~@/assets/ac.png');
    }
    .serverName {
      font-size: 14px;
      font-weight: 100;
      color: var(--themeWhite);
    }
  }
  .serverItem:hover {
    background-color: var(--themeBlack25);
  }
  .serverItem.selected {
    background-color: var(--primary);
    .serverName {
      font-weight: bold;
    }
  }
  .goToAssignment {
    margin-top: 8px;
    padding: 8px;
    border-radius: 24px;
    border: solid 2px var(--themeRed);
    background-color: var(--themeWhite05);
    i.big {
      padding: 8px;
      color: var(--themeWhite);
      margin-left: 8px;
      background-color: var(--themeOrange5);
      border-radius: 50%;
    }
    span.title {
      color: var(--themeWhite);
      font-size: 16px;
    }
    p.desc {
      font-size: 13px;
      font-weight: 100;
      color: var(--themeWhite);
      margin: 0;
      padding: 0;
    }
    @keyframes anim{
      0%{
        box-shadow: 0 0 0 0px var(--themeWhite2);
      }
      100%{
        box-shadow: 0 0 0 32px var(--themeWhite0);
      }
    }
    a.b {
      padding: 8px 16px;
      border-radius: 24px;
      margin-top: 8px;
      text-decoration: none;
      background-color: var(--themeWhite25);
      animation: anim 1s cubic-bezier(1, 0, 0, 1) infinite;
      * {
        pointer-events: none;
      }
      i {
        font-size: 16px;
        margin-left: 8px;
        color: var(--themeWhite);
      }
      label {
        font-size: 14px;
        color: var(--themeWhite);
        font-weight: 500;
      }
    }
  }
</style>
